import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { useAuthenticatedQueryFn } from '@/hooks/useAuthenticatedQuery';
import { getNodeLinkList } from '@/services/link.service';
import { QueryKey } from '@/lib/queryKeys';

export const useNodeLinks = (params: { nodeId: string; offset: number; limit: number }, options?: object) => {
  const nodeLinkListQueryFn = useAuthenticatedQueryFn(getNodeLinkList);

  const {
    data: linkList = { links: [], pagination: { count: 0, limit: 0, offset: 0 } },
    isPending: linkListIsPending,
    isFetching: linkListIsFetching,
    error: linkListError,
    refetch: refetchLinkList,
  } = useQuery({
    queryKey: [QueryKey.NodeLinkList, params.nodeId, params.offset, params.limit],
    queryFn: () => nodeLinkListQueryFn(params),
    placeholderData: keepPreviousData,
    ...options,
  });

  return { linkList, linkListIsPending, linkListIsFetching, linkListError, refetchLinkList };
};
